import { render, staticRenderFns } from "./GuestRecordTabs.vue?vue&type=template&id=0cd04229&scoped=true"
import script from "./GuestRecordTabs.vue?vue&type=script&lang=js"
export * from "./GuestRecordTabs.vue?vue&type=script&lang=js"
import style0 from "./GuestRecordTabs.vue?vue&type=style&index=0&id=0cd04229&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd04229",
  null
  
)

export default component.exports